/**
 * A report can send an admin straight to a member's edit form on the Family Tree
 * page and bring them back once the record is saved (or the form is closed).
 *   /family-tree?editMemberId=<member id>&returnTo=<report path>
 */
export const EDIT_MEMBER_PARAM = "editMemberId";
export const RETURN_TO_PARAM = "returnTo";

export function buildMemberRecordEditPath(memberId, returnTo) {
  const params = new URLSearchParams({ [EDIT_MEMBER_PARAM]: String(memberId) });
  if (returnTo) params.set(RETURN_TO_PARAM, returnTo);
  return `/family-tree?${params.toString()}`;
}

/** Only an in-app path is followed back, never another site. */
export function getSafeReturnPath(value) {
  const path = String(value || "");
  return path.startsWith("/") && !path.startsWith("//") ? path : "";
}

/** True when the page was opened from a report to edit one member's record. */
export function isMemberRecordEditLink(search = window.location.search) {
  return new URLSearchParams(search).has(EDIT_MEMBER_PARAM);
}
